module.exports = __webpack_public_path__ + "static/media/10-IMG_6716.d35e1d9a.JPG";